import React, { useEffect } from "react";
import CashflowAnalysisPage from "../../../CashflowAnalysis";
import { useDispatch, useSelector } from "react-redux";
import { setCashflowAnalysisDetails, setCashflowAnalysisError, setCashflowAnalysisLoading } from "../../../../../store/reducers/slices/cashflowAnalysis.slice";
import { getCashflowAnalysis } from "../../../../../api/cashflowAnalysis";

const CashflowAnalysisWrapper = ({onClickTabChange = () => { }}) => {
    const dispatch = useDispatch();
    const { cashflowAnalysisDetails } = useSelector(({ cashflowAnalysis }) => cashflowAnalysis);
    const { selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);

    useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch(setCashflowAnalysisLoading(true));
                const response = await getCashflowAnalysis(selectedAccountId);
                dispatch(setCashflowAnalysisDetails(response));
                dispatch(setCashflowAnalysisLoading(false));
            } catch (error) {
                dispatch(setCashflowAnalysisError(error.message));
                dispatch(setCashflowAnalysisLoading(false));
                console.log("ERROR", error);
            }
        }

        if (selectedAccountId) {
            fetchData();
        }
        // else {
        //     dispatch(setCashflowAnalysisLoading(false));
        // }
    }, [selectedAccountId])

    return (
        <CashflowAnalysisPage onClickTabChange={onClickTabChange} />
    );
};

export default CashflowAnalysisWrapper;
